import apiClient from './index'
import type { ProductGroup, ProductGroupCreate, ProductGroupUpdate } from '@/types'
import type { ListQueryParams } from './types'

const BASE_URL = '/ssp/product-groups'

export const productGroupsApi = {
  getAll: (params?: ListQueryParams) => apiClient.get<ProductGroup[]>(BASE_URL, { params })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to fetch product groups:', error)
      throw error
    }),
  getById: (id: number) => apiClient.get<ProductGroup>(`${BASE_URL}/${id}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to fetch product group:', error)
      throw error
    }),
  create: (data: ProductGroupCreate) => apiClient.post<ProductGroup>(BASE_URL, data)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to create product group:', error)
      throw error
    }),
  update: (id: number, data: ProductGroupUpdate) => apiClient.put<ProductGroup>(`${BASE_URL}/${id}`, data)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to update product group:', error)
      throw error
    }),
  delete: (id: number) => apiClient.delete<ProductGroup>(`${BASE_URL}/${id}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to delete product group:', error)
      throw error
    }),
  exportExcel: () => apiClient.get(`${BASE_URL}/export`, { responseType: 'blob' })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to export product groups to Excel:', error)
      throw error
    }),
  importExcel: (file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.post<{ created: number, updated: number, errors: number }>(`${BASE_URL}/import`, formData)
      .then(res => res.data)
      .catch(error => {
        console.error('Failed to import product groups from Excel:', error)
        throw error
      })
  }
}
